// # choice component

/*
A single choice in a list of choices.
*/

import Formatic from 'formatic';
import React from 'react';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax
import shallowEqual from 'shallowequal';

import { Duration } from '@zapier/theme';
import { Timeout } from '@zapier/common-components';

import Link from 'app/common/components/Link';
import Popover from 'app/common/components/Popover';
import PopoverMessage from 'app/common/components/PopoverMessage';
import TextOverflowMiddleEllipsis from 'app/common/components/TextOverflowMiddleEllipsis';
import watchWindowSize from 'app/common/components/watchWindowSize';
import { getRef, setRef } from 'app/common/utils/ReactUtils';

// Get the width of an element without padding.
const contentWidth = node => {
  const rect = node.getBoundingClientRect();
  const style = window.getComputedStyle(node);
  const width = rect.right - rect.left;
  return (
    width -
    parseFloat(style['padding-left']) -
    parseFloat(style['padding-right'])
  );
};

const SmartChoice = createReactClass({
  displayName: 'SmartChoice',
  mixins: [Formatic.availableMixins.helper],

  getInitialState() {
    return {
      // Actual width of the label.
      labelWidth: null,
      // Width of the content of the label.
      ellipsisWidth: null,
      isSamplePopoverOpen: false,
      isHoveringOverSample: false,
    };
  },

  onSetDomRef(node) {
    this.linkNode = node;
  },

  updateSize() {
    const node = this.linkNode;
    const rect = node.getBoundingClientRect();
    const containerWidth = rect.right - rect.left;
    let labelWidth = containerWidth;
    let ellipsisWidth;

    if (this.props.choice.sample) {
      const label = getRef(this, 'label');

      labelWidth = containerWidth * 0.67;
      const prevWidth = label.style.width;
      // Set the width so we can measure it.
      label.style.width = `${labelWidth}px`;
      ellipsisWidth = contentWidth(label);
      // Put the width back.
      label.style.width = prevWidth;
    } else {
      ellipsisWidth = contentWidth(node);
    }

    if (
      labelWidth !== this.state.labelWidth ||
      ellipsisWidth !== this.state.ellipsisWidth
    ) {
      this.setState({
        labelWidth,
        ellipsisWidth,
      });
    }
  },

  componentDidMount() {
    this.updateSize();
  },

  shouldComponentUpdate(nextProps, nextState) {
    if (
      shallowEqual(nextProps.choice, this.props.choice) &&
      shallowEqual(nextState, this.state)
    ) {
      return false;
    }
    return true;
  },

  componentDidUpdate(prevProps) {
    if (!shallowEqual(prevProps.choice, this.props.choice)) {
      this.setState({}, () => {
        this.updateSize();
      });
    }
  },

  render() {
    return this.renderWithConfig();
  },

  onSelect() {
    this.props.onSelect(this.props.choice);
  },

  overflowWidth() {
    const sample = getRef(this, 'sample');
    const label = getRef(this, 'label');
    const sampleRect = sample.getBoundingClientRect();
    const containerRect = this.linkNode.getBoundingClientRect();
    const labelRect = label.getBoundingClientRect();
    const sampleStyle = window.getComputedStyle(sample);
    const labelStyle = window.getComputedStyle(label);
    // Jeez, this is stupid, but rects don't include collapsing margins between.
    const rightLabelMargin = parseFloat(labelStyle['margin-right']);
    const leftSampleMargin = parseFloat(sampleStyle['margin-left']);

    return (
      sampleRect.width -
      (containerRect.width -
        labelRect.width -
        // Margins collapse, so get max.
        Math.max(rightLabelMargin, leftSampleMargin))
    );
  },

  onMouseEnter() {
    const overflowWidth = this.overflowWidth();

    if (overflowWidth > 0) {
      this.setState({
        isHoveringOverSample: true,
      });
    }
  },

  onOpenSamplePopover() {
    this.setState({
      isSamplePopoverOpen: true,
    });
  },

  onMouseLeave() {
    this.setState({
      isSamplePopoverOpen: false,
      isHoveringOverSample: false,
    });
  },

  // Have to determine the rect for the popover, in case it overflows.
  onSampleRect(sampleRect) {
    const overflowWidth = this.overflowWidth();
    if (overflowWidth > 0) {
      const { top, right, bottom, left } = sampleRect;
      return { top, right: right - overflowWidth, bottom, left };
    } else {
      return sampleRect;
    }
  },

  renderDefault: function() {
    const { choice } = this.props;

    const labelStyle = {
      display: 'inline-block',
    };

    const maxWidth = this.state.labelWidth;
    if (maxWidth) {
      labelStyle.maxWidth = `${maxWidth}px`;
    }

    return (
      <Link
        domRef={this.onSetDomRef}
        onClick={this.onSelect}
        style={{ cursor: 'pointer' }}
      >
        <span
          className="choice-label"
          ref={setRef(this, 'label')}
          style={labelStyle}
        >
          {maxWidth !== null ? (
            <TextOverflowMiddleEllipsis
              maxWidth={this.state.ellipsisWidth}
              value={choice.label}
            />
          ) : null}
        </span>
        <Popover onTargetRect={this.onSampleRect}>
          <span
            className="choice-sample"
            onMouseEnter={this.onMouseEnter}
            onMouseLeave={this.onMouseLeave}
            ref={setRef(this, 'sample')}
          >
            {choice.sample}
          </span>
          {choice.sample && this.state.isSamplePopoverOpen ? (
            <PopoverMessage>
              <span>{choice.sample}</span>
            </PopoverMessage>
          ) : null}
        </Popover>
        <Timeout
          delay={Duration.tooltipTimeout.default}
          isWaiting={this.state.isHoveringOverSample}
          onTimeout={this.onOpenSamplePopover}
        />
      </Link>
    );
  },
});

export default watchWindowSize(SmartChoice);
